import axios, { AxiosResponse } from 'axios';

import { ETypPozadavku } from 'enums/specialniSluzby/typPozadavku';

import { ETypPrevodu } from './uePozadavky';

export interface ISeznamisinData {
    isin: string;
    celynazev: string;
    icemitenta: string;
    nazevemitenta: string;
    datumupisu: string;
    evidencecp: string;
    pocetcp: number;
    typ?: string;
    misto: number;
    mena: string;
    bankucet: string;
    iban: string;
    typprevodu: ETypPrevodu;
}
export interface ISeznamisin {
    pocetcp: string;
    seznamisin: ISeznamisinData[];
}

interface IDataSeznamisin {
    typ?: ETypPozadavku;
    isin?: string;
    nazevemise?: string;
    idemitenta?: number; // ic
    nazevemitenta?: number;
    offset?: number;
    limit?: number;
    order?: string;
}

/* Vrátí seznam isin */
export const ueSeznamisin = (data: IDataSeznamisin) => {
    return axios({
        method: 'GET',
        url: '/UE/seznamisin',
        params: {
            ...data
        }
    }).then((resp: AxiosResponse<ISeznamisin>) => resp.data);
};
